// pdfExtractor.js
// Robust PDF text extraction for FlowTutor using pdfjs-dist
// Usage: import { extractPdfText } from './pdfExtractor';
//
// IMPORTANT: The pdf.worker.min.mjs file in /public must match the pdfjs-dist version.
// If you upgrade pdfjs-dist, copy the new worker file:
// cp node_modules/pdfjs-dist/build/pdf.worker.min.mjs public/pdf.worker.min.mjs

import * as pdfjsLib from 'pdfjs-dist/build/pdf';

// Configure worker to use local file from public directory
// This avoids CORS issues and works in production builds
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

export async function extractPdfText(file) {
  try {
    console.log('PDF extraction started for file:', file.name, 'size:', file.size);
    
    // Accepts a File object (from input[type="file"])
    if (!file) throw new Error('No file provided');
    if (!file.type.includes('pdf') && !file.name.toLowerCase().endsWith('.pdf')) {
      throw new Error('Not a PDF file');
    }
    
    console.log('Converting file to arrayBuffer...');
    const arrayBuffer = await file.arrayBuffer();
    console.log('ArrayBuffer size:', arrayBuffer.byteLength);
    
    console.log('Loading PDF document...');
    const loadingTask = pdfjsLib.getDocument({ 
      data: arrayBuffer,
      verbosity: 0 // Reduce PDF.js logging
    });
    
    const pdf = await loadingTask.promise;
    console.log('PDF loaded successfully. Pages:', pdf.numPages);
    
    let text = '';
    for (let i = 1; i <= pdf.numPages; i++) {
      console.log(`Extracting text from page ${i}...`);
      try {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map(item => item.str).join(' ');
        text += pageText + '\n';
        console.log(`Page ${i} text length:`, pageText.length);
      } catch (pageError) {
        console.error(`Error extracting page ${i}:`, pageError);
        text += `[Error extracting page ${i}]\n`;
      }
    }
    
    const finalText = text.trim();
    console.log('PDF extraction completed. Total text length:', finalText.length);
    console.log('Extracted text preview:', finalText.substring(0, 200) + '...');
    
    if (finalText.length === 0) {
      throw new Error('No text content found in PDF');
    }
    
    return finalText;
  } catch (error) {
    console.error('PDF extraction error:', error);
    throw new Error(`PDF extraction failed: ${error.message}`);
  }
}
